/**
 * TUVI - Semáforo por días transcurridos desde el inicio del cronograma.
 *
 * Regla acordada:
 *   < 45 días  -> verde  (en tiempo)
 *   >= 45 días -> amarillo (alerta)
 *   >= 60 días -> rojo (crítico)
 *
 * Se usa igual en Cronograma General y en Vista Financiera para que ambos
 * módulos muestren exactamente el mismo estado.
 */

export const DIAS_ALERTA = 45;
export const DIAS_CRITICO = 60;

/**
 * @param {string|Date|null} fechaInicio - fecha de inicio del cronograma (YYYY-MM-DD)
 * @returns {{dias:number, nivel:'verde'|'amarillo'|'rojo', color:string, bg:string, border:string, label:string}|null}
 *          null si no hay fecha o el cronograma aún no ha iniciado.
 */
export function semaforoCronograma(fechaInicio) {
  if (!fechaInicio) return null;

  const raw = typeof fechaInicio === 'string' ? fechaInicio.slice(0, 10) : null;
  const ini = raw ? new Date(raw + 'T00:00:00') : new Date(fechaInicio);
  if (isNaN(ini.getTime())) return null;

  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  ini.setHours(0, 0, 0, 0);

  const dias = Math.floor((hoy - ini) / 86400000);
  if (dias < 0) return null; // el cronograma aún no arranca

  if (dias >= DIAS_CRITICO) {
    return { dias, nivel: 'rojo', color: '#b91c1c', bg: '#fef2f2', border: '#fecaca', label: 'Crítico' };
  }
  if (dias >= DIAS_ALERTA) {
    return { dias, nivel: 'amarillo', color: '#b45309', bg: '#fffbeb', border: '#fde68a', label: 'Alerta' };
  }
  return { dias, nivel: 'verde', color: '#15803d', bg: '#f0fdf4', border: '#bbf7d0', label: 'En tiempo' };
}
